import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "foquz-icon-client-tags",
  "use": "foquz-icon-client-tags-usage",
  "viewBox": "0 0 15 15",
  "content": "<symbol viewBox=\"0 0 15 15\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"foquz-icon-client-tags\"><path d=\"M4 4h.01m9.596 4.739l-4.862 4.863a1.356 1.356 0 01-1.92 0L1 7.782V1h6.78l5.826 5.826a1.357 1.357 0 010 1.913z\" stroke=\"#73808D\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol